/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState } from 'react'
import { Col, Row, Button, Label } from 'reactstrap'
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid'
import DPSwitch from 'framework/components/DPSwitch'
import DPSearchBoxDynamicWithSwitch from 'framework/components/DPSearchBoxDynamicWithSwitch'
import { GetSubGroupSummary } from './ReportMasterController'
import ReactPaginate from 'react-paginate'
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'

const ReportMasterContent = ({
    reportUI,
    menuCode,
    toggleLocation1,
    isLocation_1_open,
    toggleLocation2,
    isLocation_2_open,
    setAllLocations_1,
    allLocations_1,
    setIsAllLocations_1,
    isAllLocations_1,
    allLocations_2,
    setAllLocations_2,
    isAllLocations_2,
    setIsAllLocations_2,
    isCustomerGroup_open,
    toggleCustomerGroup,
    allCustomerGroup,
    setAllCustomerGroups,
    isAllCustomerGroups,
    setIsAllCustomerGroups,
    allCustomers,
    setAllCustomers,
    isAllCustomers,
    setIsAllCustomers,
    isCustomer_open,
    toggleCustomer,
    allOffers,
    setAllOffers,
    isAllOffers,
    setIsAllOffers,
    isOffer_open,
    toggleOffer,
    isPayementMethod_open,
    togglePayementMethod,
    allPayementMethods,
    setAllPayementMethods,
    isAllPayementMethods,
    setIsAllPayementMethods,
    isProduct_open,
    toggleProduct,
    allProducts,
    setAllProducts,
    isAllProducts,
    setIsAllProducts,
    isStaff_open,
    toggleStaff,
    allStaff,
    setAllStaff,
    isAllStaff,
    setIsAllStaff,
    isSupplier_open,
    toggleSupplier,
    allSuppliers,
    setAllSuppliers,
    isAllSuppliers,
    setIsAllSuppliers,
    isTxnType_open,
    toggleTxnType,
    allTxnTypes,
    setAllTxnTypes,
    isAllTxnTypes,
    isUser_open,
    toggleUser,
    allUsers,
    setAllUsers,
    isAllUsers,
    setIsAllUsers,
    groups,
    setGroups,
    isSubGroup,
    setIsSubGroup,
    setSubGroups,
    subGroups,
    setCurrentGroup,
    currentGroup,
    GroupStatesArray,
    setEndGroups,
    endFroups,
    toDate,
    setToDate,
    fromDate,
    setFromDate,
    handlesave,
    displayDataset,
    isAllDates,
    setIsAllDates,
    setTxnDescription,
    txnDescription

}) => {
    const ApiURL = window.Links.ApiURL

    const [pageNo, setPageNo] = useState(1)
    const [pageSize, setPageSize] = useState(10)



    function setGroupCheck(id, curVal) {

        if (isSubGroup) {
            const objectIndex = subGroups.findIndex(obj => obj.value === id);
            const newObject = { ...subGroups[objectIndex], "ischecked": curVal };
            setSubGroups(prevDataRow => {
                const newDataRow = [...prevDataRow];
                newDataRow[objectIndex] = newObject;
                return newDataRow;
            });
        } else {
            const objectIndex = groups.findIndex(obj => obj.value === id);
            const newObject = { ...groups[objectIndex], "ischecked": curVal };
            setGroups(prevDataRow => {
                const newDataRow = [...prevDataRow];
                newDataRow[objectIndex] = newObject;
                return newDataRow;
            });
        }


    }

    function setGroupAllCheck(curVal) {

        if (isSubGroup) {
            setSubGroups(prevDataRow => {
                const newDataRow = [...prevDataRow];
                newDataRow.map((item) => {
                    item.ischecked = curVal
                })
                return newDataRow;
            });
        } else {
            setGroups(prevDataRow => {
                const newDataRow = [...prevDataRow];
                newDataRow.map((item) => {
                    item.ischecked = curVal
                })
                return newDataRow;
            });
        }

    }

    const handlePageClick = (event) => {
        setPageNo(event.selected + 1);
    };


    const indexOfLastPost = pageNo * pageSize
    const indexOfFirstPost = indexOfLastPost - pageSize
    const currentGroupRows = groups.slice(indexOfFirstPost, indexOfLastPost)

    const currentSubGroupRows = subGroups.slice(indexOfFirstPost, indexOfLastPost)


    return (
        <React.Fragment>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <Row className='mb-1' hidden={reportUI.R_LOCATIONFILTER1 ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{reportUI.R_LOCATIONCAPTION1 ? reportUI.R_LOCATIONCAPTION1 : "Locations 1"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allLocations_1.join(",")}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllLocations_1} onClick={() => { toggleLocation1() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Loc"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPSwitch
                                checked={isAllLocations_1}
                                onChange={e => {
                                    setIsAllLocations_1(e)
                                    if (e) {
                                        setAllLocations_1([])
                                    }
                                }} />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_LOCATIONFILTER2 ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{reportUI.R_LOCATIONCAPTION1 ? reportUI.R_LOCATIONCAPTION2 : "Locations 2"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allLocations_2.join(",")}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllLocations_2} onClick={() => { toggleLocation2() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Loc"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm ">
                            <DPSwitch
                                checked={isAllLocations_2}
                                onChange={e => {
                                    setIsAllLocations_2(e)
                                    if (e) {
                                        setAllLocations_2([])
                                    }

                                }} />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_DATEFILTER1 ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{reportUI.R_DATECAPTION1 ? reportUI.R_DATECAPTION1 : "From Date"}</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                textType={"date"}
                                value={fromDate}
                                disabled={isAllDates}
                                onChange={e => {
                                    setFromDate(e.target.value)
                                }}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label>{reportUI.R_DATECAPTION1 ? reportUI.R_DATECAPTION1 : "To"}</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                textType={"date"}
                                value={toDate}
                                disabled={isAllDates}
                                onChange={e => {
                                    setToDate(e.target.value)
                                }}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm ">

                            <Label>{reportUI.R_DATECAPTION1 ? reportUI.R_DATECAPTION1 : "All"}</Label>
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm ">

                            <DPSwitch
                                checked={isAllDates}
                                onChange={e => {
                                    setIsAllDates(e)

                                    if (e) {
                                        setFromDate("")
                                        setToDate("")
                                    }

                                }} />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_DATEFILTER2 ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{reportUI.R_DATECAPTION2 ? reportUI.R_DATECAPTION2 : "Date 2"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                textType={"date"}
                            />
                        </Col>
                    </Row>

                    <Row className='mb-1' hidden={reportUI.R_CUSTOMERGROUPFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{reportUI.R_CUSTOMERGROUPCAPTION ? reportUI.R_CUSTOMERGROUPCAPTION : "Cus Group"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allCustomerGroup.join(",")}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllCustomerGroups} onClick={() => { toggleCustomerGroup() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Groups"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm ">
                            <DPSwitch
                                checked={isAllCustomerGroups}
                                onChange={e => {
                                    setIsAllCustomerGroups(e)
                                    if (e) {
                                        setAllCustomerGroups([])
                                    }
                                }} />
                        </Col>
                    </Row>

                    <Row className='mb-1' hidden={reportUI.R_PRODUCTFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{reportUI.R_PRODUCTCAPTION ? reportUI.R_PRODUCTCAPTION : "Product"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allProducts.join(",")}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllProducts} onClick={() => { toggleProduct() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Products"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm ">
                            <DPSwitch
                                checked={isAllProducts}
                                onChange={e => {
                                    setIsAllProducts(e)
                                    if (e) {
                                        setAllProducts([])
                                    }
                                }} />
                        </Col>
                    </Row>

                    <Row className='mb-1' hidden={reportUI.R_TIMEFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Time"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>

                    <Row className='mb-1' hidden={reportUI.R_YEARMONTHFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Year"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_ASATDATE ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"As Date"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_TRANSACTIONTYPEFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Transaction"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allTxnTypes}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllTxnTypes} onClick={() => { toggleTxnType() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={txnDescription}
                                disabled={true}
                            />
                        </Col>


                    </Row>

                    <Row className='mb-1 mt-2' hidden={reportUI.R_GROUPFILTER ? false : true}>
                        <Col sm={12} md={10} className="mb-4-sm" style={{ paddingLeft: '25px' }}>


                            <Row>
                                <table>
                                    <thead>
                                        <tr style={{ background: "gainsboro" }}>
                                            <td>Code</td>
                                            <td>Name</td>
                                            <td>
                                                <DPSwitch
                                                    checked={isSubGroup ? subGroups.every(item => item.ischecked) : groups.every(item => item.ischecked)}
                                                    onChange={e => {
                                                        setGroupAllCheck(e)
                                                    }}
                                                    disabled={endFroups}
                                                />
                                            </td>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {isSubGroup == false ? currentGroupRows.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.value}</td>
                                                    <td>{item.label}</td>
                                                    <td><DPSwitch
                                                        checked={item.ischecked}
                                                        onChange={e => {
                                                            setGroupCheck(item.value, e)
                                                        }}
                                                    /></td>
                                                </tr>
                                            )
                                        }) : currentSubGroupRows.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.value}</td>
                                                    <td>{item.label}</td>
                                                    <td><DPSwitch
                                                        checked={item.ischecked}
                                                        onChange={e => {
                                                            setGroupCheck(item.value, e)
                                                        }}
                                                        disabled={endFroups}
                                                    /></td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </Row>
                            <Row className='mt-2'>
                                {isSubGroup ? <ReactPaginate
                                    previousLabel={'Previous'}
                                    nextLabel={'Next'}
                                    breakLabel={'...'}
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    pageCount={Math.ceil(subGroups.length / 10)}
                                    pageRangeDisplayed={2}
                                    onPageChange={handlePageClick}
                                    forcePage={pageNo - 1}
                                    renderOnZeroPageCount={null}
                                    activeClassName={'active'}
                                    activeLinkClassName={'page-link'}
                                    containerClassName={'pagination justify-content-end pagination-sm'}

                                /> : <ReactPaginate
                                    previousLabel={'Previous'}
                                    nextLabel={'Next'}
                                    breakLabel={'...'}
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    pageCount={Math.ceil(groups.length / 10)}
                                    pageRangeDisplayed={2}
                                    onPageChange={handlePageClick}
                                    forcePage={pageNo - 1}
                                    renderOnZeroPageCount={null}
                                    activeClassName={'active'}
                                    activeLinkClassName={'page-link'}
                                    containerClassName={'pagination justify-content-end pagination-sm'}

                                />}
                            </Row>

                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" onClick={async () => {
                                setEndGroups(false)
                                const checkedItems = groups.filter(item => item.ischecked)
                                const checkedItemValues = checkedItems.map(item => item.value)
                                GroupStatesArray[checkedItemValues[currentGroup]].setState([])
                                if (currentGroup > 0) {
                                    setSubGroups(GroupStatesArray[checkedItemValues[currentGroup - 1]].state)
                                    setCurrentGroup(currentGroup - 1)
                                } else if (currentGroup == 0) {
                                    setIsSubGroup(false)

                                    setCurrentGroup(0)
                                    setSubGroups([])
                                }
                            }}
                                disabled={isSubGroup ? false : true}
                            >
                                Prev
                            </Button>
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" onClick={async () => {

                                const checkedItems = groups.filter(item => item.ischecked)
                                const checkedItemValues = checkedItems.map(item => item.value)

                                if (isSubGroup == false) {
                                    if (groups.some(item => item.ischecked)) {
                                        setIsSubGroup(true)

                                        setCurrentGroup(0)
                                        setSubGroups(await GetSubGroupSummary(checkedItemValues[0]))
                                    }
                                } else {

                                    GroupStatesArray[checkedItemValues[currentGroup] - 1].setState(subGroups)

                                    if (currentGroup < checkedItemValues.length - 1) {

                                        setSubGroups(await GetSubGroupSummary(checkedItemValues[currentGroup + 1]))
                                        setCurrentGroup(currentGroup + 1)
                                    }

                                    if (groups.filter(item => item.ischecked).length - 1 == currentGroup) {
                                        setEndGroups(true)
                                    }
                                }
                            }}
                                disabled={endFroups}
                            >{isSubGroup == true && groups.filter(item => item.ischecked).length - 1 == currentGroup ? "Finish" : "Next"}</Button>
                        </Col>
                    </Row>

                </Col>
                <Col sm={12} md={6} className="mb-4-sm">

                    <Row className='mb-1' hidden={reportUI.R_CUSTOMERFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Customer"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allCustomers.join(",")}
                                disabled={true}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllCustomers} onClick={() => { toggleCustomer() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Cus"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm ">
                            <DPSwitch
                                checked={isAllCustomers}
                                onChange={e => {
                                    setIsAllCustomers(e)
                                    if (e) {
                                        setAllCustomers([])
                                    }
                                }} />
                        </Col>
                    </Row>

                    <Row className='mb-1' hidden={reportUI.R_SUPPLIERFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Supplier"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allSuppliers.join(",")}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllSuppliers} onClick={() => { toggleSupplier() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Sup"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm ">
                            <DPSwitch
                                checked={isAllSuppliers}
                                onChange={e => {
                                    setIsAllSuppliers(e)
                                    if (e) {
                                        setAllSuppliers([])
                                    }
                                }} />
                        </Col>

                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_STAFFFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Staff"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allStaff.join(",")}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllStaff} onClick={() => { toggleStaff() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Staff"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm ">
                            <DPSwitch
                                checked={isAllStaff}
                                onChange={e => {
                                    setIsAllStaff(e)
                                    if (e) {
                                        setAllStaff([])
                                    }
                                }} />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_USERFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"User"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allUsers.join(",")}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllUsers} onClick={() => { toggleUser() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Users"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm ">
                            <DPSwitch
                                checked={isAllUsers}
                                onChange={e => {
                                    setIsAllUsers(e)
                                    if (e) {
                                        setAllUsers([])
                                    }
                                }} />
                        </Col>
                    </Row>

                    <Row className='mb-1' hidden={reportUI.R_PAYMODEFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Paymode"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allPayementMethods.join(",")}
                                disabled={true}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllPayementMethods} onClick={() => { togglePayementMethod() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Paymode"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm ">
                            <DPSwitch
                                checked={isAllPayementMethods}
                                onChange={e => {
                                    setIsAllPayementMethods(e)
                                    if (e) {
                                        setAllPayementMethods([])
                                    }
                                }} />
                        </Col>
                    </Row>

                    <Row className='mb-1' hidden={reportUI.R_BINCARD ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Bincard"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_PROMOGROUPFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Promo Group"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_PROMOFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Promotion"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>

                    <Row className='mb-1' hidden={reportUI.R_ADDITIONALFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Additional"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_GROPINGMODES ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Grouping Modes"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_SKUPRODUCTFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Sku Product"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_OFFERFILTER ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Offer"}</Label>
                        </Col>
                        <Col sm={12} md={4} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                                value={allOffers.join(",")}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button color="success" className="btn-sm" disabled={isAllOffers} onClick={() => { toggleOffer() }}><i className="mdi mdi-search-web"></i></Button>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label>{"All Offer"}</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm ">
                            <DPSwitch
                                checked={isAllOffers}
                                onChange={e => {
                                    setIsAllOffers(e)
                                    if (e) {
                                        setAllOffers([])
                                    }
                                }} />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_MOVEMENT ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Movement"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                    <Row className='mb-1' hidden={reportUI.R_REPORTMODE ? false : true}>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>{"Report Mode"}</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPTextBoxforgrid
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <Row>
                        <Button
                            color="primary"
                            onClick={() => {
                                handlesave("save")
                            }}
                            disabled={displayDataset.length > 0 ? true : false}>
                            Get Report Data
                        </Button>
                    </Row>
                </Col>
            </Row>

            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Location Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isLocation_1_open}
                toggle={toggleLocation1}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"LOCATION"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'LOC_CODE'}
                FilterStr={'a'}
                SwitchData={allLocations_1}
                SetSwitchData={setAllLocations_1}
            />
            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Location Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isLocation_2_open}
                toggle={toggleLocation2}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"LOCATION"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'LOC_CODE'}
                FilterStr={'a'}
                SwitchData={allLocations_2}
                SetSwitchData={setAllLocations_2}
            />

            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Customer Group Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isCustomerGroup_open}
                toggle={toggleCustomerGroup}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"CUSTOMERGROUP"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'CG_CODE'}
                FilterStr={'a'}
                SwitchData={allCustomerGroup}
                SetSwitchData={setAllCustomerGroups}
            />

            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Customer Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isCustomer_open}
                toggle={toggleCustomer}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"CUSTOMER"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'CM_CODE'}
                FilterStr={'a'}
                SwitchData={allCustomers}
                SetSwitchData={setAllCustomers}
            />

            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Offers Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isOffer_open}
                toggle={toggleOffer}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"OFFER"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'SA_CODE'}
                FilterStr={'a'}
                SwitchData={allOffers}
                SetSwitchData={setAllOffers}
            />

            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Payment Modes Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isPayementMethod_open}
                toggle={togglePayementMethod}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"PAYMENT"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'PH_CODE'}
                FilterStr={'a'}
                SwitchData={allPayementMethods}
                SetSwitchData={setAllPayementMethods}
            />

            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Product Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isProduct_open}
                toggle={toggleProduct}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"PRODUCT"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'PLU_CODE'}
                FilterStr={'a'}
                SwitchData={allProducts}
                SetSwitchData={setAllProducts}
            />

            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Staff Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isStaff_open}
                toggle={toggleStaff}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"SA"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'SA_CODE'}
                FilterStr={'a'}
                SwitchData={allStaff}
                SetSwitchData={setAllStaff}
            />

            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Supplier Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isSupplier_open}
                toggle={toggleSupplier}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"SUPPLIER"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'SM_CODE'}
                FilterStr={'a'}
                SwitchData={allSuppliers}
                SetSwitchData={setAllSuppliers}
            />

            <DPSearchBoxDynamic
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`Transactions Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isTxnType_open}
                toggle={toggleTxnType}
                getSelect={(e, row) => {
                    setAllTxnTypes(row["TX_TYPE"])
                    setTxnDescription(row["TX_DESC"])
                    toggleTxnType()
                }}
                APIURL={ApiURL}
                URLPath={"TXN"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'TX_TYPE'}
                FilterStr={'a'}

            />

            <DPSearchBoxDynamicWithSwitch
                searchData={[]}
                columns={[]}
                defaultSorted={[]}
                mainTitle={`User Search`}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={isUser_open}
                toggle={toggleUser}
                getSelect={(data) => {
                }}
                APIURL={ApiURL}
                URLPath={"USER"}
                MenuCode={menuCode}
                KeyVal={'RPT'}
                searchBy={'UH_ID'}
                FilterStr={'a'}
                SwitchData={allUsers}
                SetSwitchData={setAllUsers}
            />

        </React.Fragment>
    )

}

export default ReportMasterContent

